var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7f8e94",
    d: "M21 1h10a2 2 0 0 1 2 2v2H19V3a2 2 0 0 1 2-2z",
    opacity: 1,
    "data-original": "#7f8e94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545c60",
    d: "M31 1h-3a2 2 0 0 1 2 2v2h3V3a2 2 0 0 0-2-2z",
    opacity: 1,
    "data-original": "#545c60"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e9e9e",
    d: "M39 7v2a4.01 4.01 0 0 1-4 4H17a4.01 4.01 0 0 1-4-4V7a2.006 2.006 0 0 1 2-2h22a2.006 2.006 0 0 1 2 2z",
    opacity: 1,
    "data-original": "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M37 5h-3a2.006 2.006 0 0 1 2 2v2a4.01 4.01 0 0 1-4 4h3a4.01 4.01 0 0 0 4-4V7a2.006 2.006 0 0 0-2-2z",
    opacity: 1,
    "data-original": "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91562d",
    d: "M51 13v19.39l-1.36 1.02c-.684-.364-1.4-.662-2.14-.89l-.38-2.66a.967.967 0 0 0-.12-.35.989.989 0 0 0-.87-.51h-4.26a1 1 0 0 0-.99.86l-.38 2.66c-.74.228-1.456.526-2.14.89l-2.15-1.62a.993.993 0 0 0-1.31.1l-3.01 3.01a.993.993 0 0 0-.1 1.31l1.62 2.15c-.364.684-.662 1.4-.89 2.14l-2.66.38a1 1 0 0 0-.86.99v4.26a1 1 0 0 0 .86.99l2.66.38c.228.74.526 1.456.89 2.14l-1.62 2.15c-.302.4-.259.96.1 1.31l1.9 1.9 1.11 1.11c.35.359.91.402 1.31.1l2.15-1.62c.684.364 1.4.662 2.14.89l.38 2.66a1 1 0 0 0 .99.86H7a6 6 0 0 1-6-6V13a6 6 0 0 1 6-6h6v2a4.01 4.01 0 0 0 4 4h18a4.01 4.01 0 0 0 4-4V7h6a6 6 0 0 1 6 6z",
    opacity: 1,
    "data-original": "#91562d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d4122",
    d: "M10.54 11A3.98 3.98 0 0 0 14 13h3a4.01 4.01 0 0 1-4-4V7h-3v2c0 .703.187 1.393.54 2zM45 7h-3a6 6 0 0 1 6 6v19.39l-.28.21c.662.215 1.304.486 1.92.81L51 32.39V13a6 6 0 0 0-6-6z",
    opacity: 1,
    "data-original": "#6d4122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M47 13v16.51a.989.989 0 0 0-.87-.51h-4.26a1 1 0 0 0-.99.86l-.38 2.66c-.74.228-1.456.526-2.14.89l-2.15-1.62a.993.993 0 0 0-1.31.1l-3.01 3.01a.993.993 0 0 0-.1 1.31l1.62 2.15c-.364.684-.662 1.4-.89 2.14l-2.66.38a1 1 0 0 0-.86.99v4.26a1 1 0 0 0 .86.99l2.66.38c.228.74.526 1.456.89 2.14l-1.62 2.15c-.302.4-.259.96.1 1.31l1.9 1.9H18L5 42V13a2.006 2.006 0 0 1 2-2h6.54A3.98 3.98 0 0 0 17 13h18a3.98 3.98 0 0 0 3.46-2H45a2.006 2.006 0 0 1 2 2z",
    opacity: 1,
    "data-original": "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M14 13h3a3.98 3.98 0 0 1-3.46-2h-3A3.98 3.98 0 0 0 14 13zM45 11h-3a2.006 2.006 0 0 1 2 2v16h2.13a.989.989 0 0 1 .87.51V13a2.006 2.006 0 0 0-2-2z",
    opacity: 1,
    "data-original": "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f8e94",
    d: "M28 9h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2zM59 41.87v4.26a1 1 0 0 1-.86.99l-2.66.38c-.228.74-.526 1.456-.89 2.14l1.62 2.15c.302.4.259.96-.1 1.31l-3.01 3.01a.993.993 0 0 1-1.31.1l-2.15-1.62c-.684.364-1.4.662-2.14.89l-.38 2.66a1 1 0 0 1-.99.86h-4.26a1 1 0 0 1-.99-.86l-.38-2.66a12.215 12.215 0 0 1-2.14-.89l-2.15 1.62a.993.993 0 0 1-1.31-.1L33.79 55l-1.9-1.9a.993.993 0 0 1-.1-1.31l1.62-2.15c-.364-.684-.662-1.4-.89-2.14l-2.66-.38a1 1 0 0 1-.86-.99v-4.26a1 1 0 0 1 .86-.99l2.66-.38c.228-.74.526-1.456.89-2.14l-1.62-2.15a.993.993 0 0 1 .1-1.31l3.01-3.01a.993.993 0 0 1 1.31-.1l2.15 1.62c.684-.364 1.4-.662 2.14-.89l.38-2.66a1 1 0 0 1 .99-.86h4.26a.989.989 0 0 1 .87.51.967.967 0 0 1 .12.35l.38 2.66c.74.228 1.456.526 2.14.89L51 32.39l.79-.6a.993.993 0 0 1 1.31.1l3.01 3.01c.359.35.402.91.1 1.31l-1.62 2.15c.364.684.662 1.4.89 2.14l2.66.38a1 1 0 0 1 .86.99z",
    opacity: 1,
    "data-original": "#7f8e94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545c60",
    d: "M44 29.51a.967.967 0 0 1 .12.35l.38 2.66c.74.228 1.456.526 2.14.89l1.08-.81c-.074-.025-.145-.057-.22-.08l-.38-2.66a.967.967 0 0 0-.12-.35.989.989 0 0 0-.87-.51h-3a.989.989 0 0 1 .87.51zM46.64 54.59c-.684.364-1.4.662-2.14.89l-.38 2.66a1 1 0 0 1-.99.86h3a1 1 0 0 0 .99-.86l.38-2.66c.074-.023.144-.054.217-.078zM58.14 40.88l-2.66-.38a12.215 12.215 0 0 0-.89-2.14l1.62-2.15a.993.993 0 0 0-.1-1.31l-3.01-3.01a.993.993 0 0 0-1.31-.1l-.79.6-.229.171L53.11 34.9c.359.35.402.91.1 1.31l-1.62 2.15c.364.684.662 1.4.89 2.14l2.66.38a1 1 0 0 1 .86.99v4.26a1 1 0 0 1-.86.99l-2.66.38c-.228.74-.526 1.456-.89 2.14l1.62 2.15c.302.4.259.96-.1 1.31l-2.341 2.341 1.021.769c.4.302.96.259 1.31-.1l3.01-3.01a.993.993 0 0 0 .1-1.31l-1.62-2.15c.364-.684.662-1.4.89-2.14l2.66-.38a1 1 0 0 0 .86-.99v-4.26a1 1 0 0 0-.86-.99z",
    opacity: 1,
    "data-original": "#545c60"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 8,
    fill: "#9e9e9e",
    opacity: 1,
    "data-original": "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M44 36a8.056 8.056 0 0 0-1.5.145 8 8 0 0 1 0 15.71A8 8 0 1 0 44 36z",
    opacity: 1,
    "data-original": "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 2,
    fill: "#7f8e94",
    opacity: 1,
    "data-original": "#7f8e94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M18 55V44a2 2 0 0 0-2-2H5z",
    opacity: 1,
    "data-original": "#cfd8dc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 9h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "m58.283 39.888-2.053-.294a12.326 12.326 0 0 0-.467-1.126l1.244-1.659a2.009 2.009 0 0 0-.186-2.615l-3.014-3.015A2 2 0 0 0 52 30.641V13a7.008 7.008 0 0 0-7-7h-5.184A3 3 0 0 0 37 4h-3V3a3 3 0 0 0-3-3H21a3 3 0 0 0-3 3v1h-3a3 3 0 0 0-2.816 2H7a7.008 7.008 0 0 0-7 7v40a7.008 7.008 0 0 0 7 7h39.133a2.009 2.009 0 0 0 1.98-1.717l.292-2.053c.382-.137.757-.292 1.126-.467l1.66 1.245c.798.593 1.91.514 2.615-.186l3.015-3.016c.7-.705.78-1.817.186-2.614l-1.244-1.66c.174-.368.33-.743.467-1.126l2.053-.294A2.008 2.008 0 0 0 60 46.133v-4.266a2.008 2.008 0 0 0-1.717-1.979zM50 13v18.886l-.469.351c-.368-.174-.743-.33-1.126-.467l-.292-2.053A1.962 1.962 0 0 0 48 29.3V13a3 3 0 0 0-3-3h-5.1a5 5 0 0 0 .1-1V8h5a5.006 5.006 0 0 1 5 5zM30.992 36.809l1.245 1.659c-.174.368-.33.743-.467 1.126l-2.053.294A2.008 2.008 0 0 0 28 41.867v4.266a2.008 2.008 0 0 0 1.717 1.979l2.053.294c.137.382.293.757.467 1.126l-1.244 1.659a2.01 2.01 0 0 0 .185 2.615l.2.194H19V44a3 3 0 0 0-3-3H6V13a1 1 0 0 1 1-1h6.026A4.977 4.977 0 0 0 17 14h18a4.977 4.977 0 0 0 3.974-2H45a1 1 0 0 1 1 1v15h-4.133a2.008 2.008 0 0 0-1.979 1.717l-.294 2.053c-.382.137-.757.293-1.126.467l-1.659-1.244a2.009 2.009 0 0 0-2.615.185l-3.016 3.016a2.012 2.012 0 0 0-.186 2.615zM17 52.586 7.414 43H16a1 1 0 0 1 1 1zM20 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1H20zm-6 4a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v2a3 3 0 0 1-3 3H17a3 3 0 0 1-3-3zM2 53V13a5.006 5.006 0 0 1 5-5h5v1a5 5 0 0 0 .1 1H7a3 3 0 0 0-3 3v29a1 1 0 0 0 .293.707l13 13A1 1 0 0 0 18 56h15.373l.821.822a2.013 2.013 0 0 0 2.615.186l1.659-1.245c.368.174.743.33 1.126.467l.253 1.77H7a5.006 5.006 0 0 1-5-5zm56-6.867-2.664.381a1 1 0 0 0-.815.7c-.207.676-.479 1.33-.811 1.955a1 1 0 0 0 .082 1.07l1.615 2.156-3.016 3.016-2.155-1.616a1 1 0 0 0-1.07-.083c-.624.333-1.279.605-1.955.812a1 1 0 0 0-.7.815L46.133 58h-4.266l-.381-2.664a1 1 0 0 0-.7-.815 10.972 10.972 0 0 1-1.955-.812 1 1 0 0 0-1.071.083l-2.155 1.616-3.015-3.016 1.615-2.155a1 1 0 0 0 .083-1.071 10.972 10.972 0 0 1-.812-1.955 1 1 0 0 0-.815-.7L30 46.133v-4.266l2.664-.381a1 1 0 0 0 .815-.7c.207-.676.479-1.331.812-1.955a1 1 0 0 0-.083-1.071l-1.616-2.155 3.016-3.015 2.155 1.615a1 1 0 0 0 1.071.083 10.972 10.972 0 0 1 1.955-.812 1 1 0 0 0 .7-.815L41.867 30h4.266l.38 2.664a1 1 0 0 0 .7.815c.676.207 1.331.479 1.955.812a1 1 0 0 0 1.07-.083l2.156-1.616 3.015 3.017-1.615 2.155a1 1 0 0 0-.082 1.07c.332.624.604 1.279.811 1.955a1 1 0 0 0 .815.7l2.662.378z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M44 35a9 9 0 1 0 9 9 9.011 9.011 0 0 0-9-9zm0 16a7 7 0 1 1 7-7 7.008 7.008 0 0 1-7 7z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M44 41a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.0679d620a2a2cc76d491c3ed4050d027.svg";
export { ForwardRef as ReactComponent };